import React, {useState} from "react";
import {
    Datagrid,
    DateField,
    Filter,
    List,
    SimpleShowLayout,
    TextField,
    TextInput,
    required,
    BooleanField,
    BooleanInput,
    NumberInput,
    NumberField,
    ArrayField,
    ArrayInput,
    SimpleFormIterator, SelectInput, ReferenceInput, ReferenceField
} from "react-admin";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";
import {PersianDateExpirationDatePicker} from "../../components/PersianDatePickers";
import EditView from "../../components/EditView";
import {DiscountTypes} from "./diacountConstants";

const DiscountFilter = (props) => (
  <Filter {...props}>
      <TextInput
          label="code"
          source={"code"}
      />
  </Filter>
);

export const DiscountList = (props) => (
  <List {...props} filters={<DiscountFilter/>}>
    <Datagrid rowClick="show">
        <TextField source="objectId"/>
        <TextField source="code"/>
        <NumberField source="percent"/>
        <BooleanField source="isDeleted"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const DiscountCreate = (props) => {
    const [expirationDate, setExpirationDate] = useState(new Date().setHours(0,0));
    function expirationDateChange(e){
        setExpirationDate(e._d.setHours(0,0))
    }
    return (
        <CreateView {...props} perPage={10}>
            <TextInput source="code" validate={required()}/>
            <NumberInput source="percent" validate={required()}/>
            <NumberInput source="limit" validate={required()}/>
            <Emoji source="description" label="توضیحات"/>
            <BooleanInput source="isDeleted" defaultValue={false}/>
            <SelectInput source="type" validate={required()} choices={DiscountTypes}/>
            <PersianDateExpirationDatePicker
                name="expirationDate"
                value={expirationDate}
                onChange={expirationDateChange}
                label={"تاریخ انقضا"}
            />
            <BooleanInput source="clinic" defaultValue={false}/>
            <BooleanInput source="subscription" defaultValue={false}/>
            <ArrayInput source="adminPlansId">
                <SimpleFormIterator>
                    <TextInput source="plansId"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistIds">
                <SimpleFormIterator>
                    <TextInput source="specialistIds"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminClinicCategories">
                <SimpleFormIterator>
                    <TextInput source="clinicCategories"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistCardIds">
                <SimpleFormIterator>
                    <TextInput source="specialistCardIds"/>
                </SimpleFormIterator>
            </ArrayInput>
        </CreateView>
    )
}


export const DiscountEdit = (props) => {
    const [expirationDate, setExpirationDate] = useState(new Date().setHours(0,0));
    function expirationDateChange(e){
        setExpirationDate(e._d.setHours(0,0))
    }

    return (
        <EditView {...props} perPage={10}>
            <TextInput source="code" validate={required()}/>
            <NumberInput source="percent" validate={required()}/>
            <NumberInput source="limit" validate={required()}/>
            <Emoji source="description" label="توضیحات"/>
            <BooleanInput source="isDeleted" defaultValue={false}/>
            <SelectInput source="type" validate={required()} choices={DiscountTypes}/>
            <PersianDateExpirationDatePicker
                name="expirationDate"
                value={expirationDate}
                onChange={expirationDateChange}
                label={"تاریخ انقضا"}
            />
            <BooleanInput source="clinic" defaultValue={false}/>
            <BooleanInput source="subscription" defaultValue={false}/>
            <ArrayInput source="adminPlansId">
                <SimpleFormIterator>
                    <TextInput source="plansId"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistIds">
                <SimpleFormIterator>
                    <TextInput source="specialistIds"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminClinicCategories">
                <SimpleFormIterator>
                    <TextInput source="clinicCategories"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistCardIds">
                <SimpleFormIterator>
                    <TextInput source="specialistCardIds"/>
                </SimpleFormIterator>
            </ArrayInput>
        </EditView>
    );
}

export const DiscountShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <TextField source="code"/>
        <NumberField source="percent"/>
        <NumberField source="limit"/>
        <TextField source="description"/>
        <NumberField source="consumed"/>
        <TextField source="typeName"/>
        <ReferenceField link="show" label="کدتخفیف انبوه" source="bulkDiscountId" reference="bulkDiscount" >
            <TextField source="objectId"/>
        </ReferenceField>
        <DateField showTime={true} locales={"fa-IR"} source="expirationDate"/>
        <BooleanField source="clinic"/>
        <BooleanField source="subscription"/>
        <ArrayField source="adminPlansId">
            <Datagrid>
                <TextField source="plansId" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminSpecialistIds">
            <Datagrid>
                <TextField source="specialistIds" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminClinicCategories">
            <Datagrid>
                <TextField source="clinicCategories" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminSpecialistCardIds">
            <Datagrid>
                <TextField source="specialistCardIds" />
            </Datagrid>
        </ArrayField>
        <BooleanField source="isDeleted"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </SimpleShowLayout>
  </ShowView>
);
